import React, { Component } from 'react';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';
import ProfilePres from '../presentational/ProfilePres';
import {
  getUserRolesSelector,
  getUserInfoSelector,
  isCorpClientSelector,
  isApplicantSelector,
} from 'src/ui/features/Login/state/loginReselect';
import { getProfileName, getProfileDetail } from '../state/profileActions';
import { PageTitle } from 'src/ui/library/PageTitle';
import {
  getProfileContactEmploymentHistoryApi,
  upsertProfileContactEmploymentHistoryApi,
  upsertProfileContactEmploymentHistorySalaryApi,
} from 'src/services/profile.service';
import moment from 'moment';
import WarningIcon from '@material-ui/icons/Warning';
import Spinner from 'src/ui/library/Spinner/Spinner';
import { withSnackbar } from 'notistack';
import { EMAIL_REGEX } from 'src/constants/constants';
import { fnShowNewDashboard } from 'src/helpers/commonFunctions';

class ProfileContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 'Information',
      relationshipContactId: props.location.state ? props.location.state.relationshipContactId : null,
    };
  }

  componentDidMount() {
    const { relationshipContactId } = this.state;
    const profileId = relationshipContactId;
    this.getProfileInfo(profileId);
  }

  getProfileInfo = profileId => {
    this.props.getProfileName(profileId);
    this.props.getProfileDetail(profileId);
  };

  tabsHandler = (event, value) => {
    this.setState({
      tab: value,
    });
  };

  getAdditionalPropsForRelatedEntities = relationshipName => {
    const isRelationship = relationshipName === 'ey_relationship_OriginatingContactId_Cont';
    let fetch,
      get,
      upsert,
      del = null;
    let relatedEntities = [];
    let sortColumn = '';
    let readOnly = false;
    let onValidate = null;
    let displayName = '';
    let tabLabel = '';

    const dateErrorValidation = [
      'ey_contact_ey_address_ContactId',
      'ey_contact_ey_contactcitizenship_ContactId',
      'ey_contact_ey_contacteducation_ContactId',
      'ey_contact_ey_contactemploymenthistory_ContactId',
      'ey_contact_ey_contactidentificationnumber_ContactId',
      'ey_contact_ey_contacttravelhistory_ContactId',
      'ey_contact_ey_contactinsurance',
      'ey_relationship_OriginatingContactId_Cont',
      'ey_ey_contactemploymenthistory_ey_contactemploymenthistorysalary_ContactEmploymentHistoryId',
    ];

    if (dateErrorValidation.includes(relationshipName)) {
      onValidate = (fields, setErrorFn) => {
        const {
          ey_startdate,
          ey_enddate,
          ey_effectivestartdate,
          ey_effectiveenddate,
          ey_travelstartdate,
          ey_travelenddate,
          ey_issuedate,
          ey_workemail,
          ey_dateofmarriage,
          ey_birthdate,
          ey_dateofdivorce,
        } = fields;
        let error = false;

        if (
          ((ey_startdate || ey_issuedate) && ey_enddate) ||
          (ey_effectivestartdate && ey_effectiveenddate) ||
          (ey_travelstartdate && ey_travelenddate)
        ) {
          let s;
          let e;

          if (
            (ey_startdate && ey_startdate.length === 11) ||
            (ey_effectivestartdate && ey_effectivestartdate.length === 11) ||
            (ey_travelstartdate && ey_travelstartdate.length === 11) ||
            (ey_issuedate && ey_issuedate.length === 11) ||
            (ey_enddate && ey_enddate.length === 11) ||
            (ey_effectiveenddate && ey_effectiveenddate.length === 11) ||
            (ey_travelenddate && ey_travelenddate.length === 11)
          ) {
            if (moment(ey_startdate || ey_effectivestartdate || ey_travelstartdate || ey_issuedate, 'DD MMM YYYY', true).isValid())
              s = moment(ey_startdate || ey_effectivestartdate || ey_travelstartdate || ey_issuedate, 'DD MMM YYYY').format('YYYYMMDD');

            if (moment(ey_enddate || ey_effectiveenddate || ey_travelenddate, 'DD MMM YYYY', true).isValid())
              e = moment(ey_enddate || ey_effectiveenddate || ey_travelenddate, 'DD MMM YYYY').format('YYYYMMDD');
          }
          if (
            (ey_startdate && ey_startdate.length === 10) ||
            (ey_effectivestartdate && ey_effectivestartdate.length === 10) ||
            (ey_travelstartdate && ey_travelstartdate.length === 10) ||
            (ey_issuedate && ey_issuedate.length === 10) ||
            (ey_enddate && ey_enddate.length === 10) ||
            (ey_effectiveenddate && ey_effectiveenddate.length === 10) ||
            (ey_travelenddate && ey_travelenddate.length === 10)
          ) {
            if (moment(ey_startdate || ey_effectivestartdate || ey_travelstartdate || ey_issuedate, 'YYYY-MM-DD', true).isValid())
              s = moment(ey_startdate || ey_effectivestartdate || ey_travelstartdate || ey_issuedate, 'YYYY-MM-DD').format('YYYYMMDD');

            if (moment(ey_enddate || ey_effectiveenddate || ey_travelenddate, 'YYYY-MM-DD', true).isValid())
              e = moment(ey_enddate || ey_effectiveenddate || ey_travelenddate, 'YYYY-MM-DD').format('YYYYMMDD');
          }
          const setErrorDate =
            (ey_enddate && 'ey_enddate') || (ey_effectiveenddate && 'ey_effectiveenddate') || (ey_travelenddate && 'ey_travelenddate');
          if (moment(e).diff(moment(s), 'days') < 0) {
            const errorMsg = (
              <span className="error-msg">
                <WarningIcon />
                <b>End Date cannot be before Start Date.</b>
              </span>
            );
            setErrorFn(setErrorDate, true, errorMsg);
            error = true;
          } else {
            setErrorFn(setErrorDate, false, null);
            error = false;
          }
        } else if (ey_workemail) {
          if (!ey_workemail.match(EMAIL_REGEX.REGEX)) {
            const errorMsgEmail = (
              <span className="error-msg">
                <WarningIcon />
                <b>Invalid Email id</b>
              </span>
            );
            setErrorFn('ey_workemail', true, errorMsgEmail);
            error = true;
          } else {
            setErrorFn('ey_workemail', false, null);
            error = false;
          }
        } else if (ey_dateofmarriage || ey_birthdate || ey_dateofdivorce) {
          const errorMsgEmail = (
            <span className="error-msg">
              <WarningIcon />
              <b>The Date cannot be in the future.</b>
            </span>
          );
          const dateFields = {
            ey_dateofmarriage: ey_dateofmarriage,
            ey_birthdate: ey_birthdate,
            ey_dateofdivorce: ey_dateofdivorce,
          };
          let dateFlags = Object.entries(dateFields).map(([key, value]) => {
            if (value !== '' && moment().diff(moment(value), 'days') < 0) {
              setErrorFn(key, true, errorMsgEmail);
              return true;
            } else {
              setErrorFn(key, false, null);
              return false;
            }
          });
          error = dateFlags.includes(true);
        }
        return error;
      };
    }
    if (relationshipName === 'ey_contact_ey_contactemploymenthistory_ContactId') {
      get = getProfileContactEmploymentHistoryApi;
      upsert = upsertProfileContactEmploymentHistoryApi;
      relatedEntities = {
        parentEntitySetName: 'ey_contactemploymenthistories',
        parentEntityName: 'ey_contactemploymenthistory',
        relationships: ['ey_ey_contactemploymenthistory_ey_contactemploymenthistorysalary_ContactEmploymentHistoryId'],
      };
    } else if (relationshipName === 'ey_ey_contactemploymenthistory_ey_contactemploymenthistorysalary_ContactEmploymentHistoryId') {
      upsert = upsertProfileContactEmploymentHistorySalaryApi;
      displayName = 'Employment Salary';
      tabLabel = 'Employment Salary';
    }

    return {
      fetch,
      get,
      upsert,
      del,
      relatedEntities,
      sortColumn,
      readOnly,
      onValidate,
      isRelationship,
      displayName,
      tabLabel,
    };
  };

  render() {
    const { relationshipContactId } = this.state;
    const loggedInUserId = this.props.userInfo.personId;
    const profileId = relationshipContactId || loggedInUserId;
    const { isLoading } = this.props;

    if (isLoading) {
      return (
        <div style={{ marginTop: '10%' }}>
          <Spinner size={70} />
        </div>
      );
    }

    return (
      <React.Fragment key={profileId}>
        <div className={fnShowNewDashboard() ? 'profile-page-container' : null}>
          <PageTitle title={intl.get('profile.pageTitle')} />
          <ProfilePres
            key={profileId}
            handleTabSelect={this.tabsHandler}
            tab={this.state.tab}
            getAdditionalPropsForRelatedEntities={this.getAdditionalPropsForRelatedEntities}
            profileId={profileId}
            {...this.props}
          />
          ;
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    userInfo: getUserInfoSelector(state),
    userRoles: getUserRolesSelector(state),
    isCorpClient: isCorpClientSelector(state),
    isApplicant: isApplicantSelector(state),
    isLoading: state.profile.isLoading,
    dynamicContent: state.profile.dynamicContent,
    name: state.profile.name,
    initials: state.profile.initials,
    relatedTabs: state.profile.relatedTabs,
  };
};

const mapDispatchToProps = {
  getProfileName,
  getProfileDetail,
};

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(ProfileContainer));
